import { isSameDay } from 'date-fns';

import { type Veranstaltung, type ZoomMeetingInfo } from '../../../dtos';

export function isMeetingInSync(
  zoomMeeting: ZoomMeetingInfo,
  experteBlockungen: Veranstaltung['experteBlockungen'],
  ablaufForToday: Veranstaltung['ablauf'][number],
): boolean {
  return (
    isMeetingScheduleInAblaufBounds(zoomMeeting, ablaufForToday) &&
    isMeetingHostListInSync(zoomMeeting, experteBlockungen)
  );
}

function isMeetingScheduleInAblaufBounds(
  zoomMeeting: ZoomMeetingInfo,
  ablaufForToday: Veranstaltung['ablauf'][number],
): boolean {
  return (
    new Date(zoomMeeting.startTime).getTime() <= ablaufForToday.starttime.getTime() && //
    ablaufForToday.endtime.getTime() <= new Date(zoomMeeting.endTime).getTime()
  );
}

/**
 * Wir gehen davon aus, dass immer der 1. Trainer der nach Experte-SAP-ID sortierten Blockungsliste
 * als Meeting-Host eingetragen und alle weiteren Trainer in dieser Reihenfolge als AlternativeHosts geführt werden.
 */
function isMeetingHostListInSync(
  zoomMeeting: ZoomMeetingInfo,
  experteBlockungen: Veranstaltung['experteBlockungen'],
): boolean {
  const meetingStartTime = new Date(zoomMeeting.startTime);
  const referentenIdsForVeranstaltung = experteBlockungen
    .filter((blockung) => isSameDay(meetingStartTime, blockung.start))
    .map((blockung) => blockung.experteId)
    .sort((a, b) => a - b);
  const referentenIdsFromZoom = [zoomMeeting.host, ...zoomMeeting.alternativeHosts].map((experte) =>
    Number(experte.sapId),
  );

  const zoomJSON = JSON.stringify(referentenIdsFromZoom);
  const veranstaltungJSON = JSON.stringify(referentenIdsForVeranstaltung);

  return zoomJSON === veranstaltungJSON;
}
